<script setup>
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    videoid: String,
});

const { t: __ } = useI18n();
</script>
<template>
    <iframe v-if="videoid" class="aspect-video w-full" :src="'https://www.youtube.com/embed/' + props.videoid"></iframe>
</template>
